export function parseBrPhone(phone) {
  const digits = (phone || '').replace(/\D/g, '');
  const withoutCountryCode =
    digits.length > 11 && digits.startsWith('55') ? digits.slice(2) : digits;

  return {
    ddd:
      withoutCountryCode.length >= 11 ? withoutCountryCode.slice(0, 2) : '11',
    number:
      withoutCountryCode.length > 9
        ? withoutCountryCode.slice(2)
        : withoutCountryCode,
  };
}
